export default __webpack_public_path__ + "static/20-d97f2166c66890ecbde54ec1aa481eac.jpg";